import type { IconProps } from "../types";

export const Camera = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="M13.997 4 15.757 7H22v13H2V7h6.243L10.004 4z" />
    <circle cx="12" cy="13" r="3" />
  </svg>
);
